/* 0.49.55 - What a Repeating display tells the cards it draws.
 *
 *   RdSearchContext  the search words (lowercase) and the cards opened
 *                    by hand (by row), so a card with Details opens by
 *                    itself while a word is found only in its hidden
 *                    part, closes again when the search changes, and a
 *                    card the visitor opened stays open, also after the
 *                    search hid it for a while.
 *   RdRowContext     the row a card belongs to: the row's own key (pk,
 *                    id, code) or, without one, its content. */
import { createContext } from 'react';

export const RdSearchContext = createContext(null);
export const RdRowContext = createContext('');

function hash(s) {
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  return (h >>> 0).toString(36);
}

/** A row's identity, the same for the same row from one render to the next. */
export function rowIdentity(row) {
  if (!row || typeof row !== 'object') return `v${hash(String(row))}`;
  for (const k of ['pk', 'id', '_id', 'key', 'code']) {
    const v = row[k];
    if (v !== undefined && v !== null && v !== '' && typeof v !== 'object') return `${k}:${v}`;
  }
  let s = '';
  try { s = JSON.stringify(row); } catch (_e) { s = String(row); }
  return `h${hash(s)}`;
}
